module.exports = __webpack_public_path__ + "c610ab25237ee849edaad42d9b928968.fbx";